import { render, staticRenderFns } from "./dagre.vue?vue&type=template&id=2472b89c&scoped=true"
import script from "./dagre.vue?vue&type=script&lang=js"
export * from "./dagre.vue?vue&type=script&lang=js"
import style0 from "./dagre.vue?vue&type=style&index=0&id=2472b89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2472b89c",
  null
  
)

export default component.exports